import * as notify from "../../../shared/notify";
import { get, put, post } from "../../../shared/data";
import { objectToParamString } from "../../../shared/helpers";

export const getNotes = (params) => {
    const paramString = objectToParamString(params);

    //TEMP: if showAllNotes, filter out isActive
    return get(`/notes?${paramString}`).then((data) => {
        return params.hasOwnProperty("showAllNotes") && !params.showAllNotes ? data.filter((n) => n.isActive) : data;
    });
};

export const updateNotes = (updatedNotes) => {
    const payload = {
        items: updatedNotes,
    };

    return put("/notes", payload);
};

export const getTaskOptions = (showShipment) => {
    const additionalOptions = showShipment ? [{ text: "Shipment", value: "shipment.standard" }] : [];

    return [
        ...additionalOptions,
        {
            text: "Measuring",
            value: "measuring.standard",
        },
        {
            text: "Photography",
            value: "photography.standard",
        },
        {
            text: "Profiling",
            value: "scheduling.default",
        },
        {
            text: "Coding",
            value: "coding.standard",
        },
        {
            text: "Image Editing",
            value: "imageediting.standard",
        },
        {
            text: "Final QA",
            value: "finalqa.standard",
        },
        {
            text: "All",
            value: "all",
        },
    ];
};

export const sendNote = (payload, source) => {
    const sourcePage = source ? `?sourcePage=${source}` : "";

    return post(`/notes${sourcePage}`, payload).then((response) => {
        if (!response || !response.responses) {
            return;
        }

        const failedData = [];
        const succeededData = response.responses.reduce((arr, item) => {
            if (item.success) {
                arr.push(item.note);
            } else if (item.errorMessage) {
                failedData.push(item.errorMessage);
            }

            return arr;
        }, []);

        if (failedData.length > 0) {
            notify.error(failedData.join(`\r\n`));
        }

        return succeededData;
    });
};
